<template>
  <aside id="sidebar">
    <!--begin::Sidebar-->
    <div id="kt_app_sidebar" class="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
      <!--begin::Logo-->
      <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
        <!--begin::Logo image-->
        <router-link to="/">
          <img alt="Logo" src="/images/layout/logo-gray-pixel-roads.png" class="h-30px app-sidebar-logo-default" />
          <img alt="Logo" src="/images/favicon/favicon-60.png" class="h-30px app-sidebar-logo-minimize">
        </router-link>
        <!--end::Logo image-->
        <!--begin::Sidebar toggle-->
        <div
          id="kt_app_sidebar_toggle"
          class="app-sidebar-toggle btn btn-icon btn-shadow btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
          :class="{
            active: isSidebarClosed
          }"
          data-kt-toggle="true"
          data-kt-toggle-state="active"
          data-kt-toggle-target="body"
          data-kt-toggle-name="app-sidebar-minimize"
          @click="toggleSidebar"
        >
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr079.svg-->
          <span class="svg-icon svg-icon-2 rotate-180">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor" />
              <path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor" />
            </svg>
          </span>
          <!--end::Svg Icon-->
        </div>
        <!--end::Sidebar toggle-->
      </div>
      <!--end::Logo-->
      <!--begin::sidebar menu-->
      <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
        <!--begin::Menu wrapper-->
        <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper hover-scroll-overlay-y" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer" data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">
          <!--begin::Menu-->
          <div class="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <router-link
                class="menu-link"
                :class="{ active: $route.name === 'home' }"
                to="/">
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <HomeIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('dashboard') }}</span>
              </router-link>
              <!--end:Menu link-->
            </div><!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('campaigns')
              }"
              @click="toggleItem('campaigns')"
            >
              <!--begin:Menu link-->
              <span
                class="menu-link"
                :class="{
                  active: $route.name === 'campaigns.index' || $route.name === 'campaigns.create'
                }"
              >
                <span class="menu-icon">
                  <BaseIcon size="xxSmall">
                    <CampaignIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('campaigns') }}</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('campaigns')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'campaigns.index' }"
                      :to="{ name: 'campaigns.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('campaign_dashboard') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'campaigns.create' }"
                      :to="{ name: 'campaigns.create' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('campaign_creator') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('advertisers')
              }"
              @click="toggleItem('advertisers')"
            >
              <!--begin:Menu link-->
              <span
                class="menu-link"
                :class="{
                  active: $route.name === 'advertisers.index' || $route.name === 'audiences.index' || $route.name === 'advertisers.create'
                }"
              >
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <AdvertiserIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('advertisers_and_audiences') }}</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('advertisers')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :to="{ name: 'advertisers.index' }"
                      :class="{ active: $route.name === 'advertisers.index' }"
                    >
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('list_advertisers') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div><!--end:Menu item-->
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :to="{ name: 'advertisers.create'}"
                      :class="{ active: $route.name === 'advertisers.create' }"
                    >
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('create_advertiser') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--end:Menu item-->
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :to="{ name: 'audiences.index'}"
                      :class="{ active: $route.name === 'audiences.index' }"
                    >
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('explore_audiences') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--end:Menu item-->
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('reports')
              }"
              @click="toggleItem('reports')"
            >
              <!--begin:Menu link-->
              <span
                class="menu-link"
                :class="{
                  'active': $route.name === 'reports.index' || $route.name === 'dashboards.index'
                }"
              >
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <ReportIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('reports') }}</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('reports')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'reports.index' }"
                      :to="{ name: 'reports.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('campaign_report') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'dashboards.index' }"
                      :to="{ name: 'dashboards.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('dashboards') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <router-link
                class="menu-link"
                :class="{ active: $route.name === 'pixels.index' }"
                :to="{ name: 'pixels.index' }">
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <PixelIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('pixels') }}</span>
              </router-link>
              <!--end:Menu link-->
            </div><!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('companies')
              }"
              @click="toggleItem('companies')"
            >
              <!--begin:Menu link-->
              <span
                class="menu-link"
                :class="{ active: $route.name === 'companies.edit' || $route.name === 'users.index' || $route.name === 'finances.index' }"
              >
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <CompanyIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('my_company') }}</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('companies')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'companies.edit' }"
                      :to="{ name: 'companies.edit' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('my_business_profile') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'users.index' }"
                      :to="{ name: 'users.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('my_users') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item" v-if="user && (user.role.slug === 'user-manager' || user.role.slug === 'administrator')">
                    <!--begin:Menu link-->
                    <router-link
                      class="menu-link"
                      :class="{ active: $route.name === 'finances.index' }"
                      :to="{ name: 'finances.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ $t('financial') }}</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <a class="menu-link" href="/terms" target="_blank">
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <PrivacyIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('privacy_and_security') }}</span>
              </a>
              <!--end:Menu link-->
            </div><!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <a class="menu-link" v-b-modal="'chat-wabee-modal'">
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <HelpIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('help_me') }}</span>
              </a>
              <!--end:Menu link-->
            </div><!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <a href="#" class="menu-link" @click.prevent="logout">
                <span class="menu-icon">
                  <BaseIcon size="xSmall">
                    <LogoutIcon />
                  </BaseIcon>
                </span>
                <span class="menu-title">{{ $t('logout') }}</span>
              </a>
              <!--end:Menu link-->
            </div><!-- END MENU ITEM -->

          </div>
          <!--end::Menu-->
        </div>
        <!--end::Menu wrapper-->
      </div>
      <!--end::sidebar menu-->
      <!--begin::Footer-->
      <!-- <div class="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6" id="kt_app_sidebar_footer">
      </div> -->
      <!--end::Footer-->
    </div>
    <!--end::Sidebar-->
  </aside>
</template>

<script>

import { VueSlideToggle } from 'vue-slide-toggle'
import UsersService from '@/modules/users/services/users-service'

import AuthService from '@/modules/auth/services/auth-service'
import AdvertiserIcon from '@/components/common/Icon/AdvertiserIcon'
import BaseIcon from '@/components/common/Icon/BaseIcon'
import CampaignIcon from '@/components/common/Icon/CampaignIcon'
import CompanyIcon from '@/components/common/Icon/CompanyIcon'
import HelpIcon from '@/components/common/Icon/HelpIcon'
import HomeIcon from '@/components/common/Icon/HomeIcon'
import LogoutIcon from '@/components/common/Icon/LogoutIcon'
import PixelIcon from '@/components/common/Icon/PixelIcon'
import PrivacyIcon from '@/components/common/Icon/PrivacyIcon'
import ReportIcon from '@/components/common/Icon/ReportIcon'

import { mapState } from 'vuex'

export default {
  name: 'TheSidebar',
  components: {
    AdvertiserIcon,
    BaseIcon,
    CampaignIcon,
    CompanyIcon,
    HelpIcon,
    HomeIcon,
    LogoutIcon,
    PixelIcon,
    PrivacyIcon,
    ReportIcon,
    VueSlideToggle
  },
  data () {
    return {
      isSidebarClosed: false,
      open: []
    }
  },
  created () {
    this.sidebar()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Logout
     */
    async logout () {
      try {
        await AuthService.logout()
        this.$router.push('/')
        location.reload()
      } catch (error) {
      }
    },
    /**
     * Check if item is open
     */
    checkIfItemIsOpen (item) {
      const index = this.open.findIndex(el => {
        return el === item
      })
      return index >= 0
    },
    /**
     * Toggle item from menu
     */
    toggleItem (item) {
      const index = this.open.findIndex(el => {
        return el === item
      })
      if (index < 0) this.open.push(item)
      else this.open.splice(index, 1)
    },
    async sidebar () {
      const sidebarState = await UsersService.getCookie('sidebar_minimize_state')
      this.isSidebarClosed = sidebarState ? !(sidebarState === 'on') : true
      this.toggleSidebar()
    },
    /**
     * Toggle sidebar
     */
    toggleSidebar () {
      this.isSidebarClosed = !this.isSidebarClosed

      if (this.isSidebarClosed) {
        document.getElementById('kt_app_body').setAttribute('data-kt-app-sidebar-minimize', 'on')
      } else {
        document.getElementById('kt_app_body').removeAttribute('data-kt-app-sidebar-minimize')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  padding: .5rem 0;

  .menu-link {
    height: 46px;
    .menu-icon {
      padding-bottom: 8px;
    }

    &.active, &:hover {
      background-color: transparent !important;

      .menu-icon {
        fill: $color10;
        padding-bottom: 5px;
        border-bottom: 3px solid $color10;
      }

      .menu-title {
        color: $color10 !important;
      }

      .menu-bullet {
        .bullet {
          background-color: $color10 !important;
        }
      }
    }
  }
}

#kt_app_sidebar_menu_wrapper {
  height: calc(100vh - 70px - 66px);
  margin-top: 50px;
  margin-bottom: 1.25rem !important;
}

#kt_app_sidebar_footer {
  height: 66px;
}

.svg-icon {
  color: $color1 !important;
}

.menu-sub {
  .menu-item {
    padding: .15rem 0;
  }
}

.menu-link {
  width: 200px;
  font-size: 13px;

  .menu-arrow:after {
    background-color: #a1a5b7 !important;
  }
}

</style>
